module.exports = __webpack_public_path__ + "img/neoxstatistics.ed762fd3.svg";